import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { ApplicationFormNumberSetting, ApplicationFormNumberSettingState, PrefixPreviewSetting } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';
import { AppContext } from '../../context';
import { translator } from '../../translator';
const MessageKey = AppContext.MessageKey;

export const actions: ActionTree<ApplicationFormNumberSettingState, RootState> = {
    /**
     * 申請管理番号情報取得
     * @returns {Promise<void>}
     */
    async show({ dispatch, commit }, id: number) {
        try {
            commit(types.SHOW_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.ApplicationFormNumber.SHOW.replace(':id', id.toString()),
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SHOW_SUCCESS, { applicationFormNumberSetting: resData });
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SHOW_FAILURE, resData.errors[0]);
        }
    },

    /**
     * 申請管理番号情報更新
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @param {ApplicationFormNumberSetting} setting 更新する申請管理番号情報
     * @returns {Promise<void>}
     */
    async update(
        { dispatch, commit, rootState },
        { id, setting }: { id: number; setting: ApplicationFormNumberSetting }
    ) {
        try {
            commit(types.UPDATE_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'put',
                    url: ApiUrl.ApplicationFormNumber.UPDATE.replace(':id', id.toString()),
                    params: setting,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.UPDATE_SUCCESS);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const message = translator(i18n, MessageKey.ApplicationFormNumber.UPDATED);
                dispatch('toastMessage', message, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.UPDATE_FAILURE, params);
        }
    },

    /**
     * プレフィックスプレビュー取得
     * @returns {Promise<void>}
     */
    async preview({ dispatch, commit, rootState }, setting: PrefixPreviewSetting) {
        try {
            commit(types.PREFIX_PREVIEW_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'post',
                    url: ApiUrl.ApplicationFormNumber.PREFIX_PREVIEW,
                    params: setting,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.PREFIX_PREVIEW_SUCCESS, { prefixPreview: resData });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.PREFIX_PREVIEW_FAILURE, params);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
